import React from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useData } from "../../../../lib/context/DataContext";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
export default function SelectProduitsVente() {
	const { produits } = useData();
	const [selectedCategorie, setSelectedCategorie] = React.useState(null);
	const produitsSelectionnes = useWatch({ name: "produitsEnVente" }) || [];

	const produitsParCategorie = React.useMemo(() => {
		return produits.data.reduce((acc, produit) => {
			if (!acc[produit.categorie]) acc[produit.categorie] = [];
			acc[produit.categorie].push(produit);
			return acc;
		}, {});
	}, [produits]);

	React.useEffect(() => {
		if (!selectedCategorie && Object.keys(produitsParCategorie).length > 0)
			setSelectedCategorie(Object.entries(produitsParCategorie)[0][0]);
	}, [selectedCategorie, produitsParCategorie]);

	const isProduitSelected = (nom) => {
		return produitsSelectionnes.some((p) => p.name === nom);
	};

	const handleToggleProduit = (produit) => {
		const current = getValues("produitsEnVente") || [];
		const alreadySelected = current.some((p) => p.name === produit.name);
		const updated = alreadySelected
			? current.filter((p) => p.name !== produit.name)
			: [...current, produit];

		setValue("produitsEnVente", updated, { shouldValidate: true });
	};

	const { setValue, getValues } = useFormContext();

	if (produitsParCategorie && selectedCategorie)
		return (
			<Stack>
				<Tabs
					value={selectedCategorie}
					onChange={(_, newValue) => setSelectedCategorie(newValue)}
				>
					{Object.entries(produitsParCategorie).map(([categorie]) => (
						<Tab
							label={categorie}
							value={categorie}
							key={categorie}
						/>
					))}
				</Tabs>
				{Object.entries(produitsParCategorie).map(
					([categorie, produits]) =>
						categorie === selectedCategorie && (
							<Grid
								container
								spacing={1}
								mt={1}
								key={categorie}
							>
								{produits.map((produit) => (
									<Grid
										size={{ xs: 6, sm: 4, md: 3 }}
										key={produit.name}
									>
										<Paper
											variant="outlined"
											sx={{
												p: 1,
												borderColor:
													isProduitSelected(
														produit.name
													) && "secondary.light",
											}}
										>
											<FormControlLabel
												control={
													<Checkbox
														checked={isProduitSelected(
															produit.name
														)}
														onChange={() =>
															handleToggleProduit(
																produit
															)
														}
													/>
												}
												label={`${produit.name} (${produit.prix}€/ ${produit.unite})`}
											/>
										</Paper>
									</Grid>
								))}
							</Grid>
						)
				)}
			</Stack>
		);
}
